import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import TimeAddOn from "@coworker/apprestructured/src/task-management/components/LogsAndComments/TimeAddOn/TimeAddOn";

type LogTabProps = {
  items: LogsTabItem[];
};

export type LogsTabItem = {
  title: string;
  content: string;
  time: string;
};

function LogsTab({ items }: LogTabProps) {
  return (
    <FixaListView id="logs">
      {items.map(({ title, content, time }, i) => (
        <FixaListViewItem
          key={i}
          title={title}
          description={content}
          addOn={<TimeAddOn>{time}</TimeAddOn>}
          emphasised
          inset
        />
      ))}
    </FixaListView>
  );
}

export default LogsTab;
